import { SeverityNumber } from '@opentelemetry/api-logs';
import { ExportResultCode } from '@opentelemetry/core';
const explicitLogMethods = {
    [SeverityNumber.TRACE]: console.debug,
    [SeverityNumber.DEBUG]: console.debug,
    [SeverityNumber.INFO]: console.info,
    [SeverityNumber.WARN]: console.warn,
    [SeverityNumber.ERROR]: console.error,
    [SeverityNumber.FATAL]: console.error,
};
const parseLogRecord = (record) => {
    let logRecordString = `[${record.severityText ||
        record.severityNumber ||
        'SEV-UNKOWN'}@${record.instrumentationScope.name}] `;
    logRecordString += `@${new Date(record.hrTime[0] * 1000).toISOString()}: `;
    if (record.spanContext) {
        logRecordString += `{trace: ${record.spanContext.traceId}, span: ${record.spanContext.spanId}, flags: ${record.spanContext.traceFlags}} `;
    }
    if (record.attributes) {
        logRecordString += `(Attributes:{${JSON.stringify(record.attributes)}}) `;
    }
    if (record.body) {
        logRecordString += `${JSON.stringify(record.body)}`;
    }
    return logRecordString;
};
export class ConsoleLogExporter {
    constructor(minimumLogLevel = SeverityNumber.UNSPECIFIED) {
        this.minimumLogLevel = minimumLogLevel;
        this.isShutdown = false;
        if (typeof console === 'undefined') {
            throw new Error('Console Not Found. Does this environment support console?');
        }
    }
    async export(logRecords, resultCallback) {
        if (this.isShutdown) {
            resultCallback({
                code: ExportResultCode.FAILED,
                error: new Error('ConsoleLogExporter is shutdown. No more logs will be exported.'),
            });
        }
        logRecords
            .filter(record => (record.severityNumber || 0) >= this.minimumLogLevel)
            .forEach(record => {
            const consoleMethod = explicitLogMethods[record.severityNumber || SeverityNumber.UNSPECIFIED] || console.log;
            consoleMethod(parseLogRecord(record));
        });
        resultCallback({
            code: ExportResultCode.SUCCESS,
        });
    }
    async shutdown() {
        this.isShutdown = true;
    }
}
//# sourceMappingURL=console-exporter.js.map